import React from "react";
import LegalLayout from "./LegalLayout";

const CSAEPolicy = () => {
  return (
    <LegalLayout title="CSAE Policy" lastUpdated="March 25, 2026">
      <section>
        <h2 className="text-2xl font-bold text-white mb-4">1. Zero Tolerance Policy</h2>
        <p>
          Braccet has a zero-tolerance policy regarding Child Sexual Abuse and Exploitation (CSAE). We are committed to maintaining a safe environment for all users and strictly prohibit any content or conduct that exploits or endangers minors.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-white mb-4">2. Prohibited Conduct</h2>
        <p>
          The following activities are strictly prohibited on Braccet and will result in immediate termination of the account and reporting to relevant authorities:
        </p>
        <ul className="list-disc pl-6 space-y-2 mt-4">
          <li>Sharing, uploading, or distributing Child Sexual Abuse Material (CSAM).</li>
          <li>Grooming or attempting to contact minors for sexual purposes.</li>
          <li>Promoting or facilitating the exploitation of children.</li>
          <li>Any form of "sextortion" or harassment involving minors.</li>
        </ul>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-white mb-4">3. Reporting Mechanisms</h2>
        <p>
          We provide multiple ways for users and third parties to report potential CSAE content:
        </p>
        <ul className="list-disc pl-6 space-y-2 mt-4">
          <li><strong>In-App Reporting:</strong> Use the "Report" button on any piece of content or profile.</li>
          <li><strong>Email:</strong> Contact our safety team directly at safety@braccet.com.</li>
          <li><strong>External Reporting:</strong> We encourage users to report CSAM to the National Center for Missing & Exploited Children (NCMEC) via their CyberTipline.</li>
        </ul>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-white mb-4">4. Content Moderation & Technology</h2>
        <p>
          We employ a combination of automated technology and human review to detect and remove CSAE content:
        </p>
        <ul className="list-disc pl-6 space-y-2 mt-4">
          <li><strong>Hashing Technology:</strong> We use industry-standard hashing solutions (like PhotoDNA) to identify known CSAM.</li>
          <li><strong>AI Scanning:</strong> Automated tools scan for potentially harmful patterns and content.</li>
          <li><strong>Human Oversight:</strong> A dedicated safety team reviews reports and flagged content 24/7.</li>
        </ul>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-white mb-4">5. Law Enforcement Cooperation</h2>
        <p>
          Braccet complies with all legal requirements to report CSAE to the National Center for Missing & Exploited Children (NCMEC) and relevant law enforcement agencies. We will provide all necessary data to assist in the investigation and prosecution of individuals involved in child exploitation.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-white mb-4">6. User Education & Support</h2>
        <p>
          We are dedicated to educating our community about online safety. We provide resources and guides for creators and brands to ensure their interactions remain professional and safe for everyone involved.
        </p>
      </section>
    </LegalLayout>
  );
};

export default CSAEPolicy;
